(function () {
  'use strict';

  angular
    .module('app.colors', []);
})();
